export default "__VITE_ASSET__Cq96O9MW__"